import { PageType } from '@dtx-company/flow-codegen/src/page/generated.types'

export const FLOWTAG_SHOW_BANNER_PAGETYPES = [PageType.Contact]
export const FLOWTAG_BANNER = 'FLOWTAG_BANNER'
